<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import EventBus from '../event-bus'

    @Component({
        props: {
            userRole: String
        }
    })

    export default class ViewFilters extends Vue {

        average = 'average'
        count = 'count'
        filter1 = 'Average'

        viewAverage() {
            this.average
            EventBus.$emit('display_average', this.average)
            this.logViewChoice('View Components by Average')
        }

        viewCount() {
            this.count
            EventBus.$emit('display_count', this.count)
            this.logViewChoice('View Components by Count')
        }

        logViewChoice(category) {
            this.role = this.userRole

            this.$ga.event({
            eventCategory: category,
            eventAction: 'click',
            eventLabel: this.role
            })
        }

    }

</script>

<template>

  <div class="viewby-container">

    <p>View by:</p>

    <el-radio-group v-model="filter1">

        <div @click="viewAverage()">
            <el-radio-button 
                label="Average"
                border>
                Average
            </el-radio-button>
        </div>

        <div @click="viewCount()">
            <el-radio-button 
                label="Count"
                border>
            </el-radio-button>
        </div>

    </el-radio-group>

  </div>

</template>

<style lang="scss" scoped>
    .viewby-container {
        width: 75px;
        p {
            font-family: Arial, sans-serif;
            font-size: 1em;
            color: #000000;
            margin: 0 5px 0 0;
        }
    }
</style>
